module.exports = __webpack_public_path__ + "img/luca-l.598dd875.jpg";